import { Card, CardBody, CardHeader } from "@/components/bootstrap/TemporaryReactstrapCompatibilityLayer";
import CardBodyDetailRow from "../layout/Card/CardBodyDetailRow";

const SeedVariantTypeCard = ({seedType, seedVariantType, clickHandler}) => {
    return(
        <Card className='seed-variant-type-card' onClick={clickHandler}>
            <CardHeader className='seed-variant-type-header'>
                <h4 className='title' >{seedType.name}</h4>
                <h4 className='number' >Nº {seedType.number}</h4>
                <h6 className='subtitle' >{seedType.scientificName}</h6>
            </CardHeader>
            <CardBody className='seed-variant-type-body'>
                <CardBodyDetailRow 
                    label='Manufacturer'
                    value={seedVariantType?.manufacturer}
                />
                <CardBodyDetailRow 
                    label='LOT Number'
                    value={seedVariantType?.lot}
                />
                <CardBodyDetailRow
                    label='Seeds left'
                    value={seedVariantType?.count ?? 'n/a'}
                />
            </CardBody>
        </Card>
    )
}

export default SeedVariantTypeCard;
